/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/quickview.js"
/*!*****************************!*\
  !*** ./src/js/quickview.js ***!
  \*****************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   quickview: () => (/* binding */ quickview)
/* harmony export */ });
// export function that binds the quick-view functionality to the product-card elements on the page
function quickview() {
  // Select all elements with the class product-card
  var productCard = document.querySelectorAll('.product-card');
  // Iterate over each product-card element
  productCard.forEach(function (element) {
    // Select the title element
    var title = element.querySelector('.variant-title'),
      // Select the input element with the name 'items[0][id]'
      variantInput = element.querySelector('input[name="items[0][id]"]'),
      // Select all elements with class quick-view-item and button
      variantSelect = element.querySelector('select'),
      addToBag = element.querySelector('button[type="submit"]');
    if (!!variantSelect) {
      variantSelect.addEventListener('change', function (event) {
        event.preventDefault();
        var selectedValue = this.value;
        variantInput.setAttribute('value', selectedValue);
      });
    }
  });
}

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		if (!(moduleId in __webpack_modules__)) {
/******/ 			delete __webpack_module_cache__[moduleId];
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!*******************************************!*\
  !*** ./src/js/product-recommendations.js ***!
  \*******************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _quickview_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./quickview.js */ "./src/js/quickview.js");


/*
BG: This function uses the recommended products API by Shopify. We firstly pass over the product ID we want to display recommended on, and then for each result, request the product.card template to get the look.
*/
var recommendedProducts = function recommendedProducts() {
  //determine if the recommendProducts class section is present
  var recommended = document.querySelector('.js-recommended-products');
  var flickityPresent = false;

  //We planning on using flickity?, we check to see if the inline attribute is present.
  if (recommended.hasAttribute('data-flickity')) {
    flickityPresent = true;
  }
  //if it is....
  if (!!recommended) {
    //Get the productID from the data attribute
    var productID = parseInt(recommended.getAttribute('data-product-id'));

    //using that productID, query the recommended products API
    fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=".concat(productID, "&limit=10")).then(function (response) {
      return response.json();
    }).then(function (_ref) {
      var products = _ref.products;
      var counter = 0;
      //with the response, loop through each product.
      products === null || products === void 0 ? void 0 : products.forEach(function (product, index) {
        counter++;
        if (product.type !== "Personalisation Extra") {
          //console.log(product.handle)
          //we run a second fetch to get the product card HTML markup
          fetch(window.Shopify.routes.root + "products/".concat(product.handle, "?view=card")).then(function (response) {
            return response.text();
          }).then(function (html) {
            var flickitySlider = recommended.querySelector('.flickity-slider');

            //if flickity isn't present, it might be that it's not being used at a particular size, so we drop it in the section anyways.
            if (flickitySlider) {
              flickitySlider.innerHTML += html;
            } else {
              recommended.innerHTML += html;
            }
            if (counter === products.length && flickityPresent && flickitySlider) {
              setTimeout(function () {
                var flkty = Flickity.data('.js-recommended-products');
                flkty.reloadCells();
                flkty.resize();
                (0,_quickview_js__WEBPACK_IMPORTED_MODULE_0__.quickview)();
              }, 1000);
            }
          });
        }
      });
    })["catch"](function (error) {
      console.error('Error:', error);
    });
  }
};
recommendedProducts();
})();

/******/ })()
;